import React from 'react';

export default () => (
    <svg width="32" height="33" viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.5 9H29.5L26.5 16L29.5 23H11.5"/>
        <path d="M11.5 9H29.5L26.5 16L29.5 23H11.5V9Z" stroke="#0B3A23" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.5 5H19.5V19H4.5"/>
        <path d="M4.5 5H19.5V19H4.5" stroke="#0B3A23" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M4.5 2V31" stroke="#0B3A23" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

);
